import { type } from 'arktype';

export const AdminSettingsSchema = type({
  'logoLightVariant?': type({
    'fullpath?': 'string | null',
  }).or(type.null),
  'logoDarkVariant?': type({
    'fullpath?': 'string | null',
  }).or(type.null),
  'defaultProductImage?': type({
    'fullpath?': 'string | null',
  }).or(type.null),
  'videoLink?': 'string | null',
  'dashboardConfiguration?': 'string | null',
  'upcomingMaintenance?': type({
    'title?': 'string | null',
    'message?': 'string | null',
    'start?': 'number | null',
    'end?': 'number | null',
  }).or(type.null),
});

export type AdminSettings = typeof AdminSettingsSchema.infer;
